:host {
  .contact-text {
    margin-bottom: 15px;
    color: #666666;
    color: var(--font-secondary);
  }

  .contact-redirect {
    font-size: 12px;
    text-align: right;
    color: #666;
    color: var(--font-secondary);

    &__text {
      strong {
        color: #0098ff;
        color: var(--blue);
      }
    }

    &__next {
      cursor: pointer;
      color: #0098ff;
      color: var(--blue);
    }
  }
}
